import {Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useDrop} from 'react-dnd';
import {useTranslation} from 'react-i18next';

import DropTarget from '@explorer/components/ui/drop-target';

const CompareDrop = ({open, accept, onDrop, side}) => {
  const {t} = useTranslation();

  const [{isOver, canDrop}, dropRef] = useDrop({
    accept,
    drop: onDrop,
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = isOver && canDrop;

  return (
    <DropTarget
      ref={dropRef}
      open={open || canDrop}
      isActive={isActive}
      sx={{
        zIndex: 'modal',
        position: 'relative',
        width: '50%',
        height: '100%',
        float: side,
        pointerEvents: 'all',
      }}
    >
      <Typography variant="h5" sx={{marginX: 3}}>
        {t('compare.dropMessage', 'Drag and drop images to compare')}
      </Typography>
    </DropTarget>
  );
};

CompareDrop.propTypes = {
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onDrop: PropTypes.func,
  open: PropTypes.bool,
  side: PropTypes.string,
};

export default CompareDrop;
